const d = 'm304-82-56-57 343-343-343-343 56-57 400 400L304-82Z';

export default d;
